
import { TRANSFER_ASSET_APPROVER_METADATA } from './transfer-asset-approver.metadata';
import { TransferAssetApproverBase } from './transfer-asset-approver.model.base';
import { CrudEntity, CrudEntityConstructionOptions } from '@scisys-uim/uim-common';


export interface TransferAssetApprover extends TransferAssetApproverBase {
}

export interface TransferAssetApproverTransient { }

export class TransferAssetApprover extends CrudEntity<TransferAssetApprover, string, TransferAssetApproverTransient> implements TransferAssetApproverTransient {
  constructor(source?: Partial<TransferAssetApprover>, options?: CrudEntityConstructionOptions<TransferAssetApprover, string, TransferAssetApproverTransient>) {
    super(TRANSFER_ASSET_APPROVER_METADATA, source, options);
  }
  
  initialiseEntityDefaults() {
    super.initialiseEntityDefaults();
  }
  
  registerPropertyCalculators() {
    super.registerPropertyCalculators();
  }
}





